import {IOrderHorseStatuses} from '../models/Order/IOrderHorseStatuses';

export function findStatusByOrderIdHorseId(horseId: number, orderId: number, statuses: IOrderHorseStatuses[]) {
  const found = statuses.find((x) => x.horseId === horseId && x.orderId === orderId);
  return found;
}
